/* Copyright (c) 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useCreateRoleBindingMutation,
  CreateRoleBindingInput,
} from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  onSuccess?: () => void;
};

export function useCreateRoleBinding({ onSuccess }: Props) {
  const [createRoleBindingMutation, { client, ...rest }] =
    useCreateRoleBindingMutation({
      onError: (error) => {
        showError(error.message);
      },
      onCompleted: () => {
        onSuccess?.();
      },
    });

  async function createRoleBinding(data: CreateRoleBindingInput) {
    await createRoleBindingMutation({
      variables: {
        input: data,
      },
    });
  }

  return [createRoleBinding, { client, ...rest }] as const;
}
